import {takeEvery} from 'redux-saga/effects'
import {
  DATA_UPLOAD_CONVERT,
  DATA_UPLOAD_DELETE_DRAFT,
  DATA_UPLOAD_GET_CHUNKED_STATUS,
  DATA_UPLOAD_GET_DRAFT,
  DATA_UPLOAD_GET_DRAFT_JOB,
  DATA_UPLOAD_GET_DRAFT_TEMPLATE,
  DATA_UPLOAD_GET_SUBJECT_ALIASES,
  DATA_UPLOAD_GET_USE_CASES,
  DATA_UPLOAD_LIST_DRAFTS,
  DATA_UPLOAD_PUT_SUBJECT_ALIASES,
  DATA_UPLOAD_SEND_CHUNK,
  DATA_UPLOAD_START_CHUNKED,
} from 'setup/redux/Actions/DataUpload/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataUploadSagas() {
  yield takeEvery(DATA_UPLOAD_GET_USE_CASES, fetchData)
  yield takeEvery(DATA_UPLOAD_CONVERT, fetchData)
  yield takeEvery(DATA_UPLOAD_START_CHUNKED, fetchData)
  yield takeEvery(DATA_UPLOAD_SEND_CHUNK, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_CHUNKED_STATUS, fetchData)
  yield takeEvery(DATA_UPLOAD_LIST_DRAFTS, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_DRAFT_JOB, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_DRAFT_TEMPLATE, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_DRAFT, fetchData)
  yield takeEvery(DATA_UPLOAD_DELETE_DRAFT, fetchData)
  yield takeEvery(DATA_UPLOAD_GET_SUBJECT_ALIASES, fetchData)
  yield takeEvery(DATA_UPLOAD_PUT_SUBJECT_ALIASES, fetchData)
}

export default dataUploadSagas
